import axios from 'axios';
import { REQUEST, SUCCESS, FAILURE } from '../../../../shared/reducers/action-type.util';
import { Storage } from 'react-jhipster';
import { any } from 'prop-types';
import { pageSize, IND } from 'app/config/constants';

export const ACTION_TYPES = {
  GET_IDENTIFIER: 'Admin/GET_IDENTIFIER',
  GET_ENPS: 'Admin/GET_ENPS',
  GET_INFO_DETAIL: 'Admin/GET_INFO_DETAIL',
  CREATE_USER: 'Admin/CREATE_USER',
  UPDATE_ADMIN: 'Admin/CREATE_USER',
  UPDATE_INFO: 'Admin/UPDATE_INFO',
  ACTIVE_USER: 'Admin/ACTIVE_USER',
  INACTIVE_USER: 'Admin/INACTIVE_USER',
  DELETE_USER: 'Admin/DELETE_USER',
  UPDATE_INFO_ENP: 'Admin/UPDATE_INFO_ENP',
  GET_LIST_ADMIN: 'Admin/GET_LIST_ADMIN',
  CREATE_ADMIN: 'Admin/CREATE_ADMIN',
  GET_LIST_ROLE: 'Admin/GET_LIST_ROLE',
  GET_INFO_VINA: 'Admin/GET_INFO_VINA',
  GET_DEPARTMENT: 'Admin/GET_DEPARTMENT',
  UPLOAD_FILE: 'Admin/UPLOAD_FILE',
  DOWNLOAD_FILE: 'Admin/DOWNLOAD_FILE',
  GET_LIST_ROLE_USER: 'Admin/GET_LIST_ROLE_USER',
  ACTIVE_USER_NCOVI: 'Admin/ACTIVE_USER_NCOVI',
  REMOVE_ACCOUNT: 'Admin/REMOVE_ACCOUNT',
  GET_LIST_ACCOUNT_REMOVED: 'Admin/GET_LIST_ACCOUNT_REMOVED'
};

const initialState = {
  loading: false,
  identifier: {} as any,
  enps: {
    users: [] as any,
    totalPage: 0
  } as any,
  infoDetail: {
    attrs: [] as any
  } as any,
  createUser: {} as any,
  updateAdmin: {} as any,
  listAdmin: {} as any,
  listRole: {} as any,
  listRoleSelect: {} as any,
  responseCreate: {} as any,
  vinaInfo: {} as any,
  updateUser: {} as any,
  activeUser: {} as any,
  inActiveUser: {} as any,
  department: {} as any,
  uploadFile: {} as any,
  uploadFileUpdateUser: {} as any,
  downloadFile: {} as any,
  errorMessageUpload: false,
  responseActiveNcovi: {} as any,
  responseRemoveAcc: {} as any,
  listAccountRemoved: {} as any
};

export type AdminManagerState = Readonly<typeof initialState>;

// Reducer
export default (state: AdminManagerState = initialState, action): AdminManagerState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_IDENTIFIER):
    case REQUEST(ACTION_TYPES.GET_ENPS):
    case REQUEST(ACTION_TYPES.GET_INFO_DETAIL):
    case REQUEST(ACTION_TYPES.CREATE_USER):
    case REQUEST(ACTION_TYPES.UPDATE_INFO):
    case REQUEST(ACTION_TYPES.ACTIVE_USER):
    case REQUEST(ACTION_TYPES.INACTIVE_USER):
    case REQUEST(ACTION_TYPES.DELETE_USER):
    case REQUEST(ACTION_TYPES.UPDATE_INFO_ENP):
    case REQUEST(ACTION_TYPES.GET_LIST_ADMIN):
    case REQUEST(ACTION_TYPES.CREATE_ADMIN):
    case REQUEST(ACTION_TYPES.UPDATE_ADMIN):
    case REQUEST(ACTION_TYPES.GET_LIST_ROLE):
    case REQUEST(ACTION_TYPES.GET_LIST_ROLE_USER):
    case REQUEST(ACTION_TYPES.GET_INFO_VINA):
    case REQUEST(ACTION_TYPES.GET_DEPARTMENT):
    case REQUEST(ACTION_TYPES.UPLOAD_FILE):
    case REQUEST(ACTION_TYPES.DOWNLOAD_FILE):
    case REQUEST(ACTION_TYPES.REMOVE_ACCOUNT):
    case REQUEST(ACTION_TYPES.GET_LIST_ACCOUNT_REMOVED):
      return {
        ...state
      };
    case REQUEST(ACTION_TYPES.ACTIVE_USER_NCOVI):
      return {
        ...state,
        loading: true
      };
    case SUCCESS(ACTION_TYPES.CREATE_USER):
    case SUCCESS(ACTION_TYPES.UPDATE_ADMIN):
      return {
        ...state,
        createUser: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.UPDATE_INFO):
      return {
        ...state,
        updateUser: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.ACTIVE_USER):
      return {
        ...state,
        activeUser: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.INACTIVE_USER):
      return {
        ...state,
        inActiveUser: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_IDENTIFIER):
    case SUCCESS(ACTION_TYPES.DELETE_USER):
      return {
        ...state,
        identifier: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_ENPS):
      return {
        ...state,
        enps: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_INFO_DETAIL):
      return {
        ...state,
        infoDetail: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_LIST_ADMIN):
      return {
        ...state,
        listAdmin: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_LIST_ROLE):
      return {
        ...state,
        listRole: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_LIST_ROLE_USER):
      return {
        ...state,
        listRoleSelect: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.CREATE_ADMIN):
      return {
        ...state,
        responseCreate: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_INFO_VINA):
      return {
        ...state,
        vinaInfo: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_DEPARTMENT):
      return {
        ...state,
        department: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.UPLOAD_FILE):
      return {
        ...state,
        uploadFile: action.payload.data,
        errorMessageUpload: false
      };

    case SUCCESS(ACTION_TYPES.DOWNLOAD_FILE):
      return {
        ...state,
        downloadFile: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.ACTIVE_USER_NCOVI):
      return {
        ...state,
        loading: false,
        responseActiveNcovi: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.REMOVE_ACCOUNT):
      return {
        ...state,
        responseRemoveAcc: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_LIST_ACCOUNT_REMOVED):
      return {
        ...state,
        listAccountRemoved: action.payload.data
      };
    case FAILURE(ACTION_TYPES.ACTIVE_USER_NCOVI):
      return {
        ...state,
        loading: false
      };

    case FAILURE(ACTION_TYPES.UPLOAD_FILE):
      return {
        ...state,
        uploadFile: action.payload.data,
        errorMessageUpload: true
      };

    case FAILURE(ACTION_TYPES.GET_LIST_ADMIN):
      return {
        ...state,
        listAdmin: {}
      };

    default:
      return state;
  }
};

const apiUrlAdmin = 'management/admin';

export const getIdentifier = (pageCurrent, values) => ({
  type: ACTION_TYPES.GET_IDENTIFIER,
  payload: axios.get('management/manager/inds', {
    params: {
      page: pageCurrent - 1,
      size: pageSize,
      search: values
    }
  })
});

export const getEnps = (pageCurrent, strSearch) => ({
  type: ACTION_TYPES.GET_ENPS,
  payload: axios.get('management/manager/enps', {
    params: {
      page: pageCurrent - 1,
      size: pageSize,
      search: strSearch.trim()
    }
  })
});

export const getInfoDetail = id => ({
  type: ACTION_TYPES.GET_INFO_DETAIL,
  payload: axios.get('management/manager/users/' + id)
});

export const createUserEnp = (param, userType) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_USER,
    payload: axios.post('management/manager/users/', param)
  });
  dispatch(getEnps(1, ''));
  return result;
};

export const createUserInd = param => {
  const result = {
    type: ACTION_TYPES.CREATE_USER,
    payload: axios.post('management/manager/users/', param)
  };
  return result;
};

export const updateInfoInd = (param, page, id) => {
  const result = {
    type: ACTION_TYPES.UPDATE_INFO,
    payload: axios.put('management/manager/users/' + id, param)
  };
  return result;
};

export const updateInfoEnp = (param, page, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_INFO_ENP,
    payload: axios.put('management/manager/users/' + id, param)
  });
  dispatch(getEnps(page, ''));
  return result;
};

export const inactiveUserEnp = (id, page, text) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.INACTIVE_USER,
    payload: axios.put('management/manager/users/' + id + '/inactive')
  });
  dispatch(getEnps(page, text));
  return result;
};

export const activeUserEnp = (id, page, text) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ACTIVE_USER,
    payload: axios.put('management/manager/users/' + id + '/active')
  });
  dispatch(getEnps(page, text));
  return result;
};

export const inactiveUserInd = (id, page, text) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.INACTIVE_USER,
    payload: axios.put('management/manager/users/' + id + '/inactive')
  });
  dispatch(getIdentifier(page, text));
  return result;
};

export const activeUserInd = (id, page, text) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ACTIVE_USER,
    payload: axios.put('management/manager/users/' + id + '/active')
  });
  dispatch(getIdentifier(page, text));
  return result;
};

export const getDepartment = () => {
  const result = {
    type: ACTION_TYPES.GET_DEPARTMENT,
    payload: axios.post('api/dvc/call/department')
  };
  return result;
};

export const uploadFile = (e, file) => async dispatch => {
  const formData = new FormData();
  formData.append('file', file);
  const result = await dispatch({
    type: ACTION_TYPES.UPLOAD_FILE,
    payload: axios.post('api/user/file/upload', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  });

  e.fileId = result.value.data.fileId;
  dispatch(createUserInd(e));
  return result;
};

export const uploadFileWhenUpdateUser = (dictParam, arrData, currentPage, id, file) => async dispatch => {
  const formData = new FormData();
  formData.append('file', file);
  const result = await dispatch({
    type: ACTION_TYPES.UPLOAD_FILE,
    payload: axios.post('api/user/file/upload', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  });
  dictParam['fileId'] = result.value.data.fileId;
  dispatch(updateInfoInd(dictParam, currentPage, id));
  return result;
};

// export const downloadFile = url => ({
//   type: ACTION_TYPES.DOWNLOAD_FILE,
//   payload: axios.get('')
// });

export const getListAdmin = (page, search, roleGroup) => ({
  type: ACTION_TYPES.GET_LIST_ADMIN,
  payload: axios.get(`${apiUrlAdmin}/list`, {
    params: {
      page: page - 1,
      size: pageSize,
      search: search,
      roleName: roleGroup
    }
  })
});

export const activeAdmin = (page, search, id) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.ACTIVE_USER,
    payload: axios.put('management/manager/users/' + id + '/active')
  });
  dispatch(getListAdmin(page, search, ''));
};

export const inActiveAdmin = (page, search, id) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.INACTIVE_USER,
    payload: axios.put('management/manager/users/' + id + '/inactive')
  });
  dispatch(getListAdmin(page, search, ''));
};

export const createAdmin = (id, listUser) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_ADMIN,
    payload: axios.post(`${apiUrlAdmin}/create`, {
      // roles: id,
      // users: listUser
      users: listUser,
      roles: id
    })
  });
  dispatch(getListAdmin(1, '', ''));
  return result;
};

export const updateAdmin = (id, listUser) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ADMIN,
    payload: axios.post(`${apiUrlAdmin}/update`, {
      roles: id,
      users: listUser
    })
  });
  dispatch(getListAdmin(1, '', ''));
  return result;
};

export const removeAccount = (id, time, phone, message, isRemoveAccount) => {
  const result = {
    type: ACTION_TYPES.REMOVE_ACCOUNT,
    payload: axios.post(`management/manager/users/remove`, null, {
      params: {
        id: id,
        time: time,
        phone: phone,
        message: message,
        isRemoveAccount: isRemoveAccount
      }
    })
  };
  return result;
};

export const getListRole = (userId?) => ({
  type: ACTION_TYPES.GET_LIST_ROLE,
  payload: axios.get(`${apiUrlAdmin}/listRole`, {
    params: {
      userId: userId
    }
  })
});

export const getListRoleUser = (useId?) => ({
  type: ACTION_TYPES.GET_LIST_ROLE_USER,
  payload: axios.get(`${apiUrlAdmin}/listRole`, {
    params: {
      userId: useId
    }
  })
});
// export const getListRoleUser = (id) => ({
//   type: ACTION_TYPES.GET_LIST_ROLE_USER,
//   payload: axios.get(`${apiUrlAdmin}/listRole/` + id)
// });

export const getInfoVina = mobile => ({
  type: ACTION_TYPES.GET_INFO_VINA,
  payload: axios.get('management/manager/vina/info', {
    params: {
      mobile: mobile
    }
  })
});

export const activeNcovi = number => ({
  type: ACTION_TYPES.ACTIVE_USER_NCOVI,
  payload: axios.get('management/manager/active/ncovi', {
    params: {
      number: number
    },
    timeout: 5 * 60 * 1000
  })
});

export const getListAccountRemoved = (pageCurrent, search) => ({
  type: ACTION_TYPES.GET_LIST_ACCOUNT_REMOVED,
  payload: axios.get('management/manager/list/account/removed', {
    params: {
      page: pageCurrent - 1,
      size: pageSize,
      search: search
    }
  })
});
